import React, { FC, useCallback } from 'react';

import { AgentAssignedCondition as AgentAssignedConditionType } from 'src/actions/rules/condition';
import ConditionRow from './ConditionRow';
import { StyledDropdown } from 'src/presentation/components/pages/rules/shared/StyledComponents';

enum AssignedToAgent {
  True = 'TRUE',
  False = 'FALSE',
}

type AgentAssignedConditionProps = {
  condition: AgentAssignedConditionType;
  index: number;
  onDelete: Function;
  onUpdate: Function;
};

const AgentAssignedCondition: FC<AgentAssignedConditionProps> = ({ condition, index, onDelete, onUpdate }) => {
  const onValueChange = useCallback(
    val => {
      condition.setValue(val === AssignedToAgent.True);
      onUpdate({ condition, index });
    },
    [condition, index, onUpdate]
  );

  return (
    <ConditionRow index={index} onDelete={onDelete} text="Assigned to">
      <StyledDropdown
        onSelect={onValueChange}
        options={assignmentOptions}
        value={condition.value ? AssignedToAgent.True : AssignedToAgent.False}
      />
    </ConditionRow>
  );
};

const assignmentOptions: { label: string; value: string }[] = [
  { label: 'Agent', value: AssignedToAgent.True },
  { label: 'Inbox', value: AssignedToAgent.False },
];

export default AgentAssignedCondition;
